import {action, getter, Module, mutation, VuexModule} from "vuex-class-component"
import {User} from "@/interface"
import API from "@/api"
import router from "../router"
import {vxm} from "@/store/index"

interface AuthData {
  AccessToken?: string
  RefreshToken?: string
  IdToken?: string
}

@Module({namespacedPath: "auth/"})
export default class AuthModule extends VuexModule {

  // auth --------------------

  @getter
  public authData: AuthData = {}

  @mutation
  private setAuthData(val: AuthData) {
    if (val.IdToken) {
      this.authData.IdToken = val.IdToken
    }
    if (val.AccessToken) {
      this.authData.AccessToken = val.AccessToken
    }
    if (val.RefreshToken) {
      this.authData.RefreshToken = val.RefreshToken
    }
    localStorage.setItem("AuthData", JSON.stringify(this.authData))
  }

  @action()
  async refresh() {
    const response = await API.refreshAuth()
    this.setAuthData(response.credential)
  }


  // get idToken(): string | null {
  //   return this.authData.IdToken
  //     ? this.authData.IdToken
  //     : null
  // }
  //
  // get accessToken(): string | null {
  //   return this.authData.AccessToken
  //     ? this.authData.AccessToken
  //     : null
  // }
  //
  // get refreshToken(): string | null {
  //   return this.authData.RefreshToken
  //     ? this.authData.RefreshToken
  //     : null
  // }

  @mutation
  private removeAuthData() {
    // this.accessToken = ""
    // this.idToken = ""
    // this.refreshToken = ""
    this.authData = {}
    localStorage.removeItem("AuthData")
  }


  // user --------------------

  @getter
  public userData: User | {} = {}

  @mutation
  private setUser(val: User) {
    this.userData = val
  }

  @mutation
  private removeUser() {
    this.userData = {}
  }

  get user(): User | null {
    return Object.keys(this.userData).length === 0 ? null : <User>this.userData
  }


  // isAuth --------------------

  @getter
  public isAuth: boolean = true

  @mutation
  private setIsAuth(bool: boolean) {
    this.isAuth = bool
  }


  private sub: string = ""

  get isAdmin(): boolean {
    if (this.user !== null) {
      return this.user.role === "ADMIN"
    } else {
      return false
    }
  }


  @mutation
  private setSub(val: string) {
    this.sub = val
    localStorage.setItem("sub", val)
  }

  @action()
  public async initialize() {
    this.setIsAuth(false)
    if (!this.sub) {
      this.setSub(localStorage.getItem("sub") || "")
    }
    const json = localStorage.getItem("AuthData")
    if (!json) {
      this.removeUser()
      this.setIsAuth(false)
      return
    }

    this.setAuthData(JSON.parse(json))

    try {
      await this.me()
    } catch (e) {
      if (e && e.code === "NotAuthorizedException") {
        if (e.message === "Access Token has expired") {
          if (this.authData.RefreshToken) {
            const token_response = await API.refreshAuth()
            this.setAuthData(token_response.credential)
          }
          await this.me()
        }
      }
    }
  }

  @action()
  public async signup(payload: { email: string, password: string, given_name: string, family_name: string }): Promise<boolean> {
    const response = await API.signup({
      email      : payload.email,
      password   : payload.password,
      given_name : payload.given_name,
      family_name: payload.family_name
    })
    if (response) {
      this.setSub(response.sub.sub)
    }
    return true
  }

  @action()
  public async verify(payload: { code: string }): Promise<void> {
    await API.verify({code: payload.code, sub: this.sub})
  }

  @action()
  public async signin(payload: { email: string, password: string }): Promise<void> {
    const response = await API.signin(payload)
    this.setAuthData(response)
    await this.me()
    await vxm.app.initialize()
  }

  @action()
  async changePassword(param: { proposed_password: string, previous_password: string }) {
    return await API.changePassword(param)
  }

  @action()
  async resetPassword(param: { email: string }) {
    return await API.resetPassword(param)
  }

  @action()
  public async signout(): Promise<any> {
    await API.signout({access_token: this.authData.AccessToken})
    this.removeAuthData()
    this.removeUser()
    this.setIsAuth(false)
    await vxm.app.finalize()
    await router.push({name: "SignIn"})
  }

  @action()
  public async me() {
    const response = await API.me()
    this.setUser(response)
    this.setIsAuth(true)
    await this.refresh()
    return response
  }
}